import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { ITableRowExtended } from "@/services/interfaces";
import IconFile from "@/components/icons/IconFile.vue";

@Component({
  name: "TableRowFile",
  components: {"icon-file": IconFile},
})
class TableRowFile extends Vue {
  @Prop({ type: Object, default: () => ({}) })
  readonly row!: ITableRowExtended;

  render() {
    if (!this.row.file) {
      return null;
    }
    return (
      <td colspan="99">
        <div class="file-row">
          <div class="file-row__title">
            <icon-file/>
            <span>{this.row.file.title}</span>
          </div>
          <a href={this.row.file.url} class="file-row__link" download={this.row.file.title}>
            Скачать
          </a>
        </div>
      </td>
    );
  }
}

export default TableRowFile;
